import React from 'react';

import { OhsConstants } from 'global-services/constants/OhsConstants';
import OhsUserLocalServices from 'user/OhsUserLocalServices';
import { useEmbeddedMobile } from 'global-components/utils/OhsUtility';

function OhsAngularIframe(props: any) {
  const isEmbeddedMobile = useEmbeddedMobile();
  const bodyUrl = window.location.href.substring(
    window.location.href.indexOf(window.location.host) + window.location.host.length
  );
  const adjustedURL = `/${OhsConstants.LegacyModuleFolder}/#${bodyUrl}`;
  const user = OhsUserLocalServices.getLocalOhsUser();
  let heightAdjust = '0px';
  if (props.isShowingBanner === true) {
    heightAdjust = user != null && user.level === 'free' ? '177.5px' : '137.5px';
  } else {
    heightAdjust = user != null && user.level === 'free' ? '125px' : '85px';
  }

  return (
    <div>
      <iframe
        style={{
          height: !isEmbeddedMobile ? `calc(100vh - ${heightAdjust})` : '100vh',
          width: 'calc(100vw)',
          boxSizing: 'border-box',
          border: '0px',
        }}
        src={adjustedURL}
        id="OhsAngularIframeId"
        title="OhsAngularIframe"
      />
    </div>
  );
}

export default OhsAngularIframe;
